(() => {
  if (window.pmCartUpgrade) return;
  window.pmCartUpgrade = true;
  const root = window.Shopify?.routes?.root || '/';
  let busy = false;
  const request = async (path, data) => {
    const response = await fetch(root + path, data === undefined ? { headers: { Accept: 'application/json' } } : {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data)
    });
    const result = await response.json();
    if (!response.ok || result.status >= 400) throw new Error(result.description || result.message || 'Please try again.');
    return result;
  };
  const sections = () => [
    { id: 'main-cart-items', section: document.getElementById('main-cart-items')?.dataset.id, selector: '.js-contents' },
    { id: 'main-cart-footer', section: document.getElementById('main-cart-footer')?.dataset.id, selector: '.js-contents' },
    { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
    { id: 'cart-live-region-text', section: 'cart-live-region-text', selector: '.shopify-section' }
  ].filter(item => item.section && document.getElementById(item.id));
  const sectionRequest = () => ({ sections: sections().map(item => item.section), sections_url: location.pathname });
  const render = cart => {
    sections().forEach(item => {
      const html = cart.sections?.[item.section];
      if (!html) return;
      const source = new DOMParser().parseFromString(html, 'text/html').querySelector(item.selector);
      const parent = document.getElementById(item.id);
      const target = parent.querySelector(item.selector) || parent;
      if (source) target.innerHTML = source.innerHTML;
    });
    document.dispatchEvent(new CustomEvent('pm:cart-updated', { detail: cart }));
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: cart });
    }
    document.querySelector('pm-cart-discount')?.showCart(cart);
  };
  const run = async task => {
    if (busy) return;
    busy = true;
    const controls = [...document.querySelectorAll('pm-cart-discount button, pm-cart-impulse button, #checkout')];
    const states = controls.map(control => control.disabled);
    controls.forEach(control => { control.disabled = true; });
    try { await task(); }
    finally { controls.forEach((control, index) => { if (control.isConnected) control.disabled = states[index]; }); busy = false; }
  };
  // Don't allow the native checkout submission to overtake an in-flight cart update.
  document.addEventListener('submit', event => {
    if (busy && event.target.id === 'cart') event.preventDefault();
  }, true);
  class CartDiscount extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.input = this.querySelector('input');
      this.status = this.querySelector('[role="status"]');
      this.querySelector('[data-apply]').addEventListener('click', () => this.apply());
      this.querySelector('[data-gift-checkout]')?.addEventListener('click', () => {
        if (busy) return;
        // Use the existing checkout control so pickup validation still runs.
        const checkout = document.getElementById('checkout');
        if (checkout && !checkout.disabled) checkout.click();
      });
      this.input.addEventListener('keydown', event => {
        if (event.key === 'Enter') { event.preventDefault(); this.apply(); }
      });
      this.refresh = () => request('cart.js').then(cart => this.showCart(cart)).catch(() => {});
      this.refresh();
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, this.refresh);
    }
    disconnectedCallback() { this.unsubscribe?.(); }
    isWelcome(code) { return (this.dataset.welcomeCodes || '').split(',').includes(String(code).toUpperCase()); }
    showCart(cart) {
      this.showCodes(cart.discount_codes || []);
      const code = (cart.discount_codes || []).find(item => this.isWelcome(item.code));
      if (!code) { this.status.textContent = 'Applied discounts carry through to checkout.'; return; }
      if (code.applicable) {
        const applications = (cart.cart_level_discount_applications || []).filter(item => this.isWelcome(item.title) || /purefect meals welcome/i.test(item.title));
        const savings = applications.reduce((sum, item) => sum + Number(item.total_allocated_amount || 0), 0);
        this.status.textContent = savings > 0 ? `Welcome discount applied: ${this.money(savings, cart.currency)} saved. Your code carries through to checkout.` : 'Welcome code applied. Your updated savings appear in the order total.';
      } else if (this.dataset.welcomeState === 'used') {
        this.status.textContent = 'Your welcome discount has already been redeemed. This offer is limited to one use per customer.';
      } else {
        const remaining = Math.max(0, 6000 - Number(cart.original_total_price || 0));
        this.status.textContent = remaining > 0
          ? `Add ${this.money(remaining, cart.currency)} more to meet the $60 minimum for the $20 welcome discount. Valid only if you have not used it before; eligibility is confirmed at checkout.`
          : 'This welcome code is not applied. It can be used once per customer and cannot combine with other discounts. Sign in at checkout to confirm eligibility.';
      }
    }
    money(cents, currency = 'USD') { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency}).format(cents / 100); }
    showCodes(codes) {
      const list = this.querySelector('[data-codes]');
      list.replaceChildren();
      codes.filter(discount => !/^PM-LUNCH-(5|10)$/i.test(discount.code)).forEach(discount => {
        const row = document.createElement('div');
        row.className = 'pm-cart-discount__code';
        const label = document.createElement('span');
        label.textContent = `${discount.code} · ${discount.applicable ? 'Applied' : 'Not applied'}`;
        const remove = document.createElement('button');
        remove.type = 'button'; remove.textContent = 'Remove';
        remove.setAttribute('aria-label', `Remove discount ${discount.code}`);
        remove.addEventListener('click', () => this.apply(discount.code));
        row.append(label, remove); list.append(row);
      });
    }
    apply(removeCode) {
      const code = this.input.value.trim();
      if (!removeCode && !code) { this.status.textContent = 'Enter a discount code first.'; this.input.focus(); return; }
      return run(async () => {
        this.status.textContent = removeCode ? 'Removing code…' : 'Checking your code…';
        try {
          const current = await request('cart.js');
          const codes = (current.discount_codes || []).map(item => item.code).filter(item => item.toLowerCase() !== (removeCode || code).toLowerCase());
          if (!removeCode) codes.push(code);
          const cart = await request('cart/update.js', { discount: codes.join(','), ...sectionRequest() });
          render(cart);
          const applied = cart.discount_codes?.find(item => item.code.toLowerCase() === code.toLowerCase());
          if (removeCode) this.status.textContent = 'Code removed. Your total is updated.';
          else if (this.isWelcome(code)) { this.showCart(cart); if (applied?.applicable) this.input.value = ''; }
          else if (applied?.applicable) { this.status.textContent = 'Discount applied. It will carry through to checkout.'; this.input.value = ''; }
          else this.status.textContent = 'This code is not applied. Check its minimum order, usage limit, and combination rules.';
        } catch (error) { this.status.textContent = window.PurefectOrderSupport.format(error.message); }
      });
    }
  }
  class CartImpulse extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.track = this.querySelector('[data-track]');
      this.previous = this.querySelector('[data-previous]');
      this.next = this.querySelector('[data-next]');
      this.updateArrows = () => {
        this.previous.hidden = this.track.scrollLeft <= 2;
        this.next.hidden = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
      };
      this.track.addEventListener('scroll', this.updateArrows, { passive: true });
      this.resize = new ResizeObserver(this.updateArrows); this.resize.observe(this.track);
      [this.previous, this.next].forEach((button, index) => button.addEventListener('click', () => {
        this.track.scrollBy({ left: this.track.clientWidth * (index ? .85 : -.85), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }));
      this.querySelectorAll('form').forEach(form => {
        const select = form.querySelector('select');
        select?.addEventListener('change', () => {
          const option = select.selectedOptions[0];
          form.closest('article').querySelector('[data-price]').textContent = option.dataset.price || '';
        });
        form.addEventListener('submit', event => {
          event.preventDefault();
          if (!form.reportValidity()) return;
          run(async () => {
            const status = form.querySelector('[role="status"]');
            status.textContent = 'Adding…';
            let added = false;
            try {
              const variant = new FormData(form).get('id');
              await request('cart/add.js', { items: [{ id: Number(variant), quantity: 1 }] });
              added = true;
              const cart = await request('cart/update.js', sectionRequest());
              if (document.getElementById('main-cart-footer')?.hidden) { location.reload(); return; }
              render(cart); status.textContent = 'Added to your cart.';
            } catch (error) {
              if (added) { status.textContent = 'Added. Refreshing your cart…'; location.reload(); }
              else status.textContent = window.PurefectOrderSupport.format(error.message);
            }
          });
        });
      });
      this.updateArrows();
    }
    disconnectedCallback() { this.resize?.disconnect(); }
  }
  customElements.define('pm-cart-discount', CartDiscount);
  customElements.define('pm-cart-impulse', CartImpulse);
})();
